import { FC } from 'react';
import { FooterContainer } from '../modules/footer/footer.container';
import { PrivacyPoliciesContainer } from '../modules/privacy-policies/PrivacyPolicies.container';
import { isRunningInAppWebview } from '../utils/isRunningInAppWebview';

export const PrivacyAndPolicies: FC = () => {
  return (
    <>
      <PrivacyPoliciesContainer />
      {!isRunningInAppWebview() && <FooterContainer />}
    </>
  );
};
